import { useCallback } from 'react';
import { useEffect, useRef, useState } from 'react';
import throttle from 'lodash-es/throttle';

export const useCheckOverFlowTabs = <T extends HTMLElement>() => {
  const ref = useRef<T>(null);
  const [showButton, setShowButtons] = useState(false);

  useEffect(() => {
    const checkOverflow = throttle(() => {
      if (ref.current) {
        const { scrollWidth, clientWidth } = ref.current;

        setShowButtons(scrollWidth > clientWidth);
      }
    }, 400);

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, []);

  const handleScroll = useCallback((direction: 'left' | 'right') => {
    if (ref.current) {
      const SCROLL_AMOUNT = 100;

      ref.current.scrollBy({
        left: direction === 'left' ? -SCROLL_AMOUNT : SCROLL_AMOUNT,
        behavior: 'smooth',
      });
    }
  }, []);

  return {
    ref,
    handleScroll,
    showButton,
  };
};
